module.exports = __webpack_public_path__ + "static/img/fire.415b8807.png";